import { render, staticRenderFns } from "./confirm-dialog.vue?vue&type=template&id=1527bccd&scoped=true&"
import script from "./confirm-dialog.vue?vue&type=script&lang=js&"
export * from "./confirm-dialog.vue?vue&type=script&lang=js&"
import style0 from "./confirm-dialog.vue?vue&type=style&index=0&id=1527bccd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527bccd",
  null
  
)

export default component.exports